import { put, call, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GET_ENTITY,
  GET_ENTITY_SUCCESS,
  GET_ENTITY_ERROR,
  RESET_GET_ENTITY,
  GetEntity,
  ResetGetEntity,
} from '../types/enargas/get-entity'
import {
  MIGRATE_ENTITY,
  MIGRATE_ENTITY_SUCCESS,
  MIGRATE_ENTITY_ERROR,
  RESET_MIGRATE_ENTITY,
  MigrateEntity,
  ResetMigrateEntity
} from '../types/enargas/migrate-entity'



function* migrateEntity({ payload }) {
  console.log('migrateEntity saga called with payload:', payload)
  try {
    const { response, error } = yield call(services.enargas.migrateEntity, payload)
    if (error) {
      yield put({
        type: MIGRATE_ENTITY_ERROR,
        payload: error,
      })
    } else {
      // Verificar que response sea un Blob válido
      if (response instanceof Blob) {
        // Crear un blob y descargar el archivo
        const url = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = url;
        link.download = `enargas-export-${new Date().toISOString().split('T')[0]}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        yield put({
          type: MIGRATE_ENTITY_SUCCESS,
          payload: response,
        })
      } else {
        console.error('Response is not a Blob:', response);
        yield put({
          type: MIGRATE_ENTITY_ERROR,
          payload: 'Error: La respuesta no es un archivo válido',
        })
      }
    }
  } catch (error) {
    console.error('Error in migrateEntity saga:', error);
    yield put({
      type: MIGRATE_ENTITY_ERROR,
      payload: 'Error al obtener TXT de la entidad',
    })
  }
}

function* getEntity({ payload }) {
  try {
    const { response, error } = yield call(services.enargas.getEntity, payload)
    if (error) {
      yield put({
        type: GET_ENTITY_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ENTITY_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ENTITY_ERROR,
      payload: 'Error al obtener entidad',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetEntity>(GET_ENTITY, getEntity)
  yield takeLatest<MigrateEntity>(MIGRATE_ENTITY, migrateEntity)
}
